import React, { Component } from 'react';
import logo from './logo.svg';
import './App.scss';
import Envelope from './invitation/Envelope';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Envelope>
          
        </Envelope>
      </div>
    );
  }
}

export default App;
